import mapFunction from './mapResources';

export default mapFunction('working_hours_types', {
    isFetching: false,
    items: [] 
});